export const SKIP_PARSING_ESPOTS_EXCEPTIONS_USER_DATA_KEY = 'SKIP_PARSING_ESPOTS_EXCEPTIONS';
